module.exports = __webpack_public_path__ + "media/nature.6a99b1dd.mp4";